import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import cx from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import values from 'ramda/src/values';
import Icon from '@components/@core/Icon';
import Rating from '@components/@core/Rating';
import { AverageTooltip } from '@components/ScorecardToolTips';
import OrgEmployeeList from './OrgEmployeeList';
import ManageActions from '~/actions/manage';

const moment = extendMoment(originalMoment);

const OrgChart = ({ onReport, onSelectMenu }) => {
    const companyIds = useSelector((state) => state.app.selectedCompany);
    const userIds = useSelector((state) => state.app.selectedEmployee.users);
    const companies = useSelector((state) => state.app.companies);

    const dispatch = useDispatch();
    const location = useLocation();

    const data = useSelector((state) => state.manage.companyPerformanceReviews);
    const [isOpen, setIsOpen] = useState(false);
    const [column, setColumn] = useState(null);

    useEffect(() => {
        let _companyIds, _userIds;
        if (companyIds[0] < 0) _companyIds = companies.map((item) => item.id);
        else _companyIds = companyIds;
        if (userIds === null || userIds.length === 0 || userIds[0] < 0) _userIds = null;
        else _userIds = userIds;

        const payload = {
            companyId: _companyIds,
            page: location.state?.page ?? 1,
            perPage: location.state?.per ?? 25,
            dateStart: location.state?.dateStart ?? moment().startOf('year').format('YYYY-MM-DD'),
            dateEnd: location.state?.dateEnd ?? moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        };
        dispatch(ManageActions.companyperformancereviewsstatsRequest(payload));
    }, []);

    const handleVisibility = (index) => {
        setIsOpen((prev) => !prev);
        setColumn(index);
    };

    return (
        <>
            <div className="list-title mt-2 pb-2 ps-0 desktop-screen">
                <div className="d-flex-4 dsl-m12 me-3 me-md-0">Departments</div>
                <div className="d-flex-2 dsl-m12 ms-2 text-end">Teams</div>
                <div className="d-flex-2 dsl-m12 ps-3 ps-md-0 text-end">Employees</div>
                <div className="d-flex-3 dsl-m12 text-end">Completed</div>
                <div className="d-flex-1" />
                <div className="d-flex-3 dsl-m12 text-start">Score</div>
            </div>
            {data.departments?.map((item, index) => {
                const { department, totals } = item;
                const employees = values(item?.employees);
                return (
                    <div key={index}>
                        <div className="d-flex ssm-column list-item cursor-pointer py-3" onClick={() => handleVisibility(index)}>
                            <div className="d-flex-4 list-item-title w-100">
                                <Icon name={`fas fa-angle-${isOpen && column === index ? 'down' : 'right'}`} size={14} color="#343f4b" className="icon-text" />
                                <OverlayTrigger placement="bottom-end" overlay={AverageTooltip(totals, department?.name || department)}>
                                    <span className="dsl-b14 ms-2">{department?.name || department}</span>
                                </OverlayTrigger>
                            </div>
                            <div className="d-flex-2 text-end ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-30">Team</label>
                                <span className="dsl-b14">0</span>
                            </div>
                            <div className="d-flex-2 text-end ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-30">Employee</label>
                                <span className="dsl-b14">{totals?.employees?.count || 0}</span>
                            </div>
                            <div className="d-flex-3 text-end ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-30">Completed</label>
                                <span className="dsl-b14">{totals?.reviews_completed?.count || 0}</span>
                            </div>
                            <div className="d-flex-1" />
                            <div className="d-flex d-flex-3 dsl-m12 text-start ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-30">Score</label>
                                <Rating score={totals?.completed_average_star_score?.stars} />
                            </div>
                        </div>
                        <div className={cx('ml-3', isOpen && column === index ? 'd-block' : 'd-none')}>
                            {employees.length !== 0 && <OrgEmployeeList employees={employees} onReport={onReport} onSelectMenu={onSelectMenu} />}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default OrgChart;
